import toastr from 'toastr';

// Global toastr ayarları
toastr.options = {
  closeButton: true,
  progressBar: false,
  positionClass: 'toast-bottom-right',
  preventDuplicates: true,
  timeOut: 4000,
  showEasing: 'swing',
  hideEasing: 'linear',
  showMethod: 'fadeIn',
  hideMethod: 'fadeOut',
  showDuration: '300',
  hideDuration: '500',
  newestOnTop: true,
};

// Test bildirimleri için örnek kullanım
// document.addEventListener('DOMContentLoaded', () => {
//   toastr.success('İşlem başarıyla tamamlandı', 'Başarılı');
//   toastr.error('Bir hata oluştu', 'Hata');
//   toastr.warning('Dikkat edilmesi gereken durum', 'Uyarı');
//   toastr.info('Bilgilendirme mesajı', 'Bilgi');
// });

export default toastr;
